import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';
import axios from 'axios';
import './crm-contact-list.scss';
import { MobileCardList } from '../../components/mobile/MobileCardList';
import { TuanTraMobile } from '../tuan-tra-mobile/TuanTraMobile';
import { io } from 'socket.io-client';
import { nameserver } from '../../config/nameServer';
import {
  DataGrid,
  DataGridRef,
  // Sorting,
  // Selection,
  // HeaderFilter,
  Scrolling,
  SearchPanel,
  ColumnChooser,
  Export,
  Column,
  Toolbar,
  Item,
  LoadPanel,
  DataGridTypes,
  HeaderFilter,
} from 'devextreme-react/data-grid';
import DateBox from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import { confirm } from 'devextreme/ui/dialog';
import DropDownButton, {
  DropDownButtonTypes,
} from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';

import {
  // ContactStatus as ContactStatusType,
  Contact,
  Device,
} from '../../types/crm-contact';

import { FormPopup, ContactNewForm, ContactPanel } from '../../components';
import { ContactStatus } from '../../components';

import { CONTACT_STATUS_LIST, newDevice } from '../../shared/constants';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { ContactEditForm } from '../../components/library/contact-new-form/ContactEditForm';

const editCellStatusRender = () => (
  <SelectBox
    className='cell-info'
    dataSource={CONTACT_STATUS_LIST}
    itemRender={ContactStatus}
    fieldRender={fieldRender}
  />
);

const fieldRender = (text: string) => (
  <>
    <ContactStatus text={text} />
    <TextBox readOnly />
  </>
);

const onExporting = (e: DataGridTypes.ExportingEvent) => {
  if (e.format === 'pdf') {
    const doc = new JsPdf();
    exportDataGridToPdf({
      jsPDFDocument: doc,
      component: e.component,
    }).then(() => {
      doc.save('Contacts.pdf');
    });
  } else {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Contacts');

    exportDataGridToXLSX({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Contacts.xlsx'
        );
      });
    });
    e.cancel = true;
  }
};

// const dropDownOptions = { width: 'auto' };
const exportFormats = ['xlsx', 'pdf'];

export const CRMContactList = () => {
  const [gridDataSource, setGridDataSource] = useState([]);
  const [isPanelOpened, setPanelOpened] = useState(false);
  const [contactId, setContactId] = useState<number>(0);
  const [popupVisible, setPopupVisible] = useState(false);
  const [formDataDefaults, setFormDataDefaults] = useState({ ...newDevice });
  const gridRef = useRef<DataGridRef>(null);
  const [isMobile, setIsMobile] = useState(false);
  const newContactData = useRef<any | null>(null);
  const [isEdit, setIsEdit] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const filterCaList = [
    { text: 'Tất cả', value: 'All' },
    { text: 'Ca 1', value: '1' },
    { text: 'Ca 2', value: '2' },
    { text: 'Ca 3', value: '3' },
  ];
  const filterTrangThaiList = [
    { text: 'Tất cả', value: 'ALL' },
    { text: 'OK', value: 'OK' },
    { text: 'Not OK', value: 'NOT_OK' },
  ];
  const [trangThai, setTrangThai] = useState({
    text: 'Trạng thái',
    value: 'ALL',
  });
  const [ca, setCa] = useState(filterCaList[0]);
  const filterByCa = useCallback(
    (e: DropDownButtonTypes.SelectionChangedEvent) => {
      const item = e.item;

      if (item.value === 'All') {
        gridRef.current?.instance().clearFilter();
      } else {
        gridRef.current?.instance().filter(['CA', '=', item.value]);
      }

      setCa(item);
    },
    []
  );
  const getSafeUrl = (url: string) => {
    if (!url) return '';
    // Nếu url hợp lệ (http/https)
    if (/^https?:\/\//i.test(url)) return url;
    // Nếu chỉ là path relative
    return `${nameserver}${url.startsWith('/') ? '' : '/'}${url}`;
  };
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreen();
    window.addEventListener('resize', checkScreen);

    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    loadData(selectedDate);
  }, []);
  const loadData = async (date = selectedDate) => {
    const ngay = new Date(date).toISOString().split('T')[0];
    // const userId = 118929;
    // console.log('userid', userId);

    const res = await axios.get(
      `${nameserver}/api/tuantrathietbi?ngay=${ngay}`
    );

    setGridDataSource(res.data);
  };
  useEffect(() => {
    const socket = io(`${nameserver}`);

    socket.on('connect', () => {
      console.log('Connected socket');
    });

    socket.on('tuantra_updated', (data) => {
      console.log('Realtime update', data);
      loadData();
    });

    return () => {
      socket.disconnect();
    };
  }, [loadData]);

  const changePopupVisibility = useCallback((isVisble) => {
    setPopupVisible(isVisble);
  }, []);

  const changePanelOpened = useCallback(() => {
    setPanelOpened(!isPanelOpened);
    gridRef.current?.instance().option('focusedRowIndex', -1);
  }, [isPanelOpened]);

  const changePanelPinned = useCallback(() => {
    gridRef.current?.instance().updateDimensions();
  }, []);

  const onAddContactClick = useCallback(() => {
    setIsEdit(false);
    newContactData.current = null;
    setFormDataDefaults({ ...newDevice });
    setPopupVisible(true);
  }, []);

  const onRowClick = useCallback(({ data }: DataGridTypes.RowClickEvent) => {
    setContactId(data.id);
    setPanelOpened(true);
  }, []);

  const refresh = useCallback(() => {
    gridRef.current?.instance().refresh();
  }, []);

  const onDataChanged = useCallback((data) => {
    newContactData.current = data;
  }, []);

  const onSaveClick = useCallback(async () => {
    const currentCa = getCurrentCa();

    const recordCa = Number(newContactData.current?.CA);
    console.log('DATA SAVE:', newContactData.current);
    console.log('ID:', newContactData.current?.ID);
    console.log('CA record:', newContactData.current?.CA);
    console.log('CA current:', currentCa);
    if (!recordCa || recordCa !== currentCa) {
      notify('Chỉ được sửa trong ca hiện tại', 'warning');
      return;
    }

    const today = new Date().toISOString().split('T')[0];
    const selected = new Date(selectedDate).toISOString().split('T')[0];

    if (today !== selected) {
      notify('Chỉ được sửa dữ liệu hôm nay', 'warning');
      return;
    }

    try {
      if (newContactData.current?.ID) {
        const now = new Date();
        const formatted = `${now.getFullYear()}-${String(
          now.getMonth() + 1
        ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(
          now.getHours()
        ).padStart(2, '0')}:${String(now.getMinutes()).padStart(
          2,
          '0'
        )}:${String(now.getSeconds()).padStart(2, '0')}`;

        if (!newContactData.current.KET_QUA) {
          notify({
            message: 'Vui lòng chọn trạng thái trước khi lưu',
            type: 'warning',
            displayTime: 2000,
            position: {
              at: 'center',
              my: 'center',
            },
          });
          return;
        }
        if ((newContactData.current.KET_QUA == 'Not OK')) {
          if (!newContactData.current.DE_XUAT) {
            notify({
              message: 'Vui lòng nhập đề xuất trước khi lưu',
              type: 'warning',
              displayTime: 2000,
              position: {
                at: 'center',
                my: 'center',
              },
            });
            return;
          }
        }
        const dataToSave = {
          ...newContactData.current,
          CREATED_BY: localStorage.getItem('fullname'),
          NGAY_SUA: formatted,
        };
        console.log('datatoSave: ', dataToSave);

        await axios.put(
          `${nameserver}/api/tuantra/${newContactData.current.ID}`,
          dataToSave
        );
      }

      notify('Lưu thành công', 'success');
      loadData();
      setPopupVisible(false);
    } catch (err) {
      notify('Lỗi khi lưu', 'error');
    }
  }, []);
  const getCurrentCa = () => {
    const hour = new Date().getHours();

    if (hour >= 6 && hour < 14) return 1;
    if (hour >= 14 && hour < 22) return 2;
    return 3;
  };
  const currentCaRef = useRef(getCurrentCa());

  useEffect(() => {
    const interval = setInterval(() => {
      const newCa = getCurrentCa();

      if (newCa !== currentCaRef.current) {
        currentCaRef.current = newCa;
        loadData(selectedDate);
        notify('Đã sang ca mới, tự động cập nhật dữ liệu', 'info');
      }
    }, 60000); // kiểm tra mỗi 1 phút

    return () => clearInterval(interval);
  }, [selectedDate]);
  const filterByTrangThai = useCallback((e) => {
    const item = e.item;
    setTrangThai(item);

    const grid = gridRef.current?.instance();
    if (!grid) return;

    if (item.value === 'ALL') {
      // Xóa mọi filter
      grid.clearFilter();
      return;
    }

    // Các cột cần filter
    const ketQuaFields = [
      'C1_CA1',
      'C1_CA2',
      'C1_CA3',
      'C2_CA1',
      'C2_CA2',
      'C2_CA3',
      'C3_CA1',
      'C3_CA2',
      'C3_CA3',
    ];

    const filterArray: any[] = [];

    ketQuaFields.forEach((field, index) => {
      if (index > 0) filterArray.push('or');
      filterArray.push([field, '=', item.value === 'OK' ? 'OK' : 'Not OK']);
    });

    grid.filter(filterArray);
  }, []);
  const deviceList = (gridDataSource as any).map(
    (item: any) => item.TEN_THIET_BI
  );
  const formatTime = (dateStr) => {
    if (!dateStr) return '';

    const d = new Date(dateStr);

    return d.toLocaleString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  const uniqueDeviceList = Array.from(new Set(deviceList));
  const renderKetQua = (field) => {
    return (cell) => {
      const value = cell.data[field];
      const recordId = cell.data['ID_' + field];

      // 🔥 thêm 2 dòng này
      const deXuat = cell.data['DX_' + field];
      const anh = cell.data['ANH_' + field];
      const user = cell.data['USER_' + field];
      const time = cell.data['TIME_' + field];
      const currentCa = getCurrentCa();

      const ca = parseInt(field.split('_CA')[1]);

      const today = new Date().toISOString().split('T')[0];
      const selected = new Date(selectedDate).toISOString().split('T')[0];

      const isEditable = ca === currentCa && today === selected;

      const handleClick = async () => {
        if (!recordId || !isEditable) return;

        const res = await axios.get(`${nameserver}/api/tuantra/${recordId}`);

        const dataWithId = {
          ...res.data,
          ID: recordId,
        };

        setIsEdit(true);
        setPopupData(dataWithId);
        setPopupVisible(true);
      };

      return (
        <div
          style={{
            textAlign: 'center',
            padding: 4,
            backgroundColor:
              value === 'OK'
                ? '#e6ffe6'
                : value === 'Not OK'
                ? '#ffe6e6'
                : 'white',
            borderRadius: 4,
            opacity: isEditable ? 1 : 0.5,
          }}
        >
          {/* OK / Not OK */}
          <div
            onClick={handleClick}
            style={{
              color: value === 'OK' ? 'green' : 'red',
              fontWeight: 'bold',
              cursor: isEditable ? 'pointer' : 'not-allowed',
            }}
          >
            {value || '--'}
          </div>
          {user && (
            <div
              style={{
                fontSize: 11,
                fontWeight: 'bold',
                color: '#1565c0', // xanh đậm
                marginTop: 4,
              }}
            >
              👤 {user}
            </div>
          )}

          {time && (
            <div
              style={{
                fontSize: 10,
                color: '#ff6f00', // cam nổi bật
                fontWeight: 600,
              }}
            >
              🕒 {formatTime(time)}
            </div>
          )}

          {/* 🔥 HIỂN THỊ ĐỀ XUẤT */}
          {value === 'Not OK' && deXuat && (
            <div
              style={{
                fontSize: 11,
                marginTop: 4,
                color: '#d32f2f',
                fontWeight: 'bold',
                background: '#fff3f3',
                padding: '2px 4px',
                borderRadius: 4,
              }}
            >
              {deXuat}
            </div>
          )}

          {/* 🔥 HIỂN THỊ ẢNH */}
          {value === 'Not OK' && anh && (
            <img
              src={getSafeUrl(anh)}
              alt=''
              style={{
                width: 40,
                height: 40,
                marginTop: 4,
                borderRadius: 4,
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!anh) return;
                window.open(getSafeUrl(anh), '_blank');
              }}
            />
          )}
        </div>
      );
    };
  };

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper view-wrapper-contact-list list-page'>
        {isMobile ? (
          <TuanTraMobile />
        ) : (
          <DataGrid
            className='grid theme-dependent'
            noDataText=''
            height='100%'
            width='100%'
            dataSource={gridDataSource}
            keyExpr='ID'
            onRowClick={onRowClick}
            onExporting={onExporting}
            allowColumnReordering
            showBorders
            showColumnLines={true}
            showRowLines={true}
            ref={gridRef}
            //Thêm mới
            columnAutoWidth
            columnHidingEnabled={false}
            wordWrapEnabled
            columnResizingMode='widget'
          >
            <LoadPanel showPane={false} />
            <SearchPanel visible placeholder='Tìm kiếm thiết bị' />
            <ColumnChooser enabled />
            <Export enabled allowExportSelectedData formats={exportFormats} />
            {/* <Selection
              selectAllMode='allPages'
              showCheckBoxesMode='always'
              mode='multiple'
            /> */}
            {/* <HeaderFilter visible /> */}
            {/* <Sorting mode='multiple' /> */}
            {/* <Scrolling mode='virtual' /> */}
            <Scrolling
              mode='standard'
              showScrollbar='always'
              useNative={true}
            />
            <Toolbar>
              <Item location='before'>
                <div className='grid-header'>Ngày</div>
              </Item>
              {/* <Item location='before' locateInMenu='auto'>
                <DropDownButton
                  items={filterCaList}
                  displayExpr='text'
                  keyExpr='value'
                  stylingMode='contained'
                  icon='filter'
                  text={ca.text}
                  dropDownOptions={{ width: 140 }}
                  useSelectMode
                  onSelectionChanged={filterByCa}
                />
              </Item> */}

              <Item location='before'>
                <DateBox
                  type='date'
                  value={selectedDate}
                  displayFormat='dd/MM/yyyy'
                  onValueChanged={(e) => {
                    setSelectedDate(e.value);
                    loadData(e.value);
                  }}
                  width={150}
                />
              </Item>

              <Item location='before' locateInMenu='auto'>
                <DropDownButton
                  items={filterTrangThaiList}
                  displayExpr='text'
                  keyExpr='value'
                  stylingMode='contained'
                  icon='filter'
                  text={trangThai.text}
                  dropDownOptions={{ width: 120 }}
                  useSelectMode
                  onSelectionChanged={filterByTrangThai}
                />
              </Item>
              <Item location='before' locateInMenu='auto'>
                <SelectBox
                  dataSource={uniqueDeviceList} // dùng thẳng, không cần unique
                  placeholder='Chọn thiết bị...'
                  searchEnabled={true} // cho phép gõ tìm kiếm
                  showClearButton={true} // nút xóa filter
                  onValueChanged={(e) => {
                    const grid = gridRef.current?.instance();
                    if (!grid) return;

                    if (!e.value) {
                      grid.clearFilter(); // xóa filter nếu clear
                      return;
                    }

                    grid.filter(['TEN_THIET_BI', '=', e.value]);
                  }}
                  width={200}
                />
              </Item>
              {/* <Item location='after' locateInMenu='auto'>
                <Button
                  icon='plus'
                  text='Add Contact'
                  type='default'
                  stylingMode='contained'
                  onClick={onAddContactClick}
                />
              </Item> */}
              {/* <Item
                location='after'
                locateInMenu='auto'
                showText='inMenu'
                widget='dxButton'
              >
                <Button
                  icon='refresh'
                  text='Refresh'
                  stylingMode='text'
                  onClick={refresh}
                />
              </Item> */}
              <Item location='after' locateInMenu='auto'>
                <div className='separator' />
              </Item>
              <Item name='exportButton' />
              <Item location='after' locateInMenu='auto'>
                <div className='separator' />
              </Item>
              {/* <Item name='columnChooserButton' locateInMenu='auto' /> */}
              <Item name='searchPanel' locateInMenu='auto' />
              {/* <Item>
                <div className='grid-header'>
                  {' '}
                  {localStorage.getItem('userName')}
                </div>
              </Item> */}
            </Toolbar>
            <Column
              dataField='ID'
              caption='STT'
              // hidingPriority={5}
              minWidth={50}
              allowSorting={false}
            />
            <Column
              dataField='TEN_THIET_BI'
              caption='Thiết bị'
              // hidingPriority={5}
              minWidth={100}
              allowSorting={false}
            />
            <Column
              dataField='TEN_BO_PHAN'
              caption='Bộ phận'
              // hidingPriority={5}
              minWidth={100}
              allowSorting={false}
            />
            <Column
              dataField='NOI_DUNG_KIEM_TRA'
              caption='Nội dung kiểm tra'
              // hidingPriority={4}
              minWidth={150}
              allowSorting={false}
            />
            <Column
              dataField='PHUONG_PHAP_KIEM_TRA'
              caption='Phương pháp kiểm tra'
              // hidingPriority={3}
              minWidth={100}
              allowSorting={false}
            />
            <Column
              dataField='TIEU_CHUAN'
              caption='Tiêu chuẩn'
              // hidingPriority={3}
              minWidth={170}
              allowSorting={false}
            />
            <Column caption='Tuần tra cấp 1'>
              <Column caption='Ca 1'>
                <Column dataField='TT_C1_CA1' caption='Trạng thái' />
                <Column
                  dataField='C1_CA1'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C1_CA1')}
                />
              </Column>
              <Column caption='Ca 2'>
                {/* <Column dataField='C1_CA2' caption='Trạng thái' /> */}
                <Column dataField='TT_C1_CA2' caption='Trạng thái' />
                <Column
                  dataField='C1_CA2'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C1_CA2')}
                />
                {/* <Column dataField='C1_CA2_OK' caption='OK/Not OK' /> */}
              </Column>
              <Column caption='Ca 3'>
                <Column dataField='TT_C1_CA3' caption='Trạng thái' />
                <Column
                  dataField='C1_CA3'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C1_CA3')}
                />
                {/* <Column dataField='C1_CA3_OK' caption='OK/Not OK' /> */}
              </Column>
            </Column>
            <Column caption='Tuần tra cấp 2'>
              <Column caption='Ca 1'>
                <Column dataField='TT_C2_CA1' caption='Trạng thái' />
                <Column
                  dataField='C2_CA1'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C2_CA1')}
                />
                {/* <Column dataField='C1_CA1_OK' caption='OK/Not OK' /> */}
              </Column>
              <Column caption='Ca 2'>
                <Column dataField='TT_C2_CA2' caption='Trạng thái' />
                <Column
                  dataField='C2_CA2'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C2_CA2')}
                />
                {/* <Column dataField='C1_CA2_OK' caption='OK/Not OK' /> */}
              </Column>
              <Column caption='Ca 3'>
                <Column dataField='TT_C2_CA3' caption='Trạng thái' />
                <Column
                  dataField='C2_CA3'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C2_CA3')}
                />
                {/* <Column dataField='C1_CA3_OK' caption='OK/Not OK' /> */}
              </Column>
            </Column>
            <Column caption='Tuần tra cấp 3'>
              <Column caption='Ca 1'>
                <Column dataField='TT_C3_CA1' caption='Trạng thái' />
                <Column
                  dataField='C3_CA1'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C3_CA1')}
                />
                {/* <Column dataField='C3_CA1_OK' caption='OK/Not OK' /> */}
              </Column>
              <Column caption='Ca 2'>
                <Column dataField='TT_C3_CA2' caption='Trạng thái' />
                <Column
                  dataField='C3_CA2'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C3_CA2')}
                />
                {/* <Column dataField='C3_CA2_OK' caption='OK/Not OK' /> */}
              </Column>
              <Column caption='Ca 3'>
                <Column dataField='TT_C3_CA3' caption='Trạng thái' />
                <Column
                  dataField='C3_CA3'
                  caption='OK/Not OK'
                  cellRender={renderKetQua('C3_CA3')}
                />
                {/* <Column dataField='C3_CA3_OK' caption='OK/Not OK' /> */}
              </Column>
            </Column>
          </DataGrid>
        )}
        <ContactPanel
          contactId={contactId}
          isOpened={isPanelOpened}
          changePanelOpened={changePanelOpened}
          changePanelPinned={changePanelPinned}
        />
        <FormPopup
          title={isEdit ? 'Sửa tuần tra' : 'Thêm tuần tra'}
          visible={popupVisible}
          setVisible={changePopupVisibility}
          onSave={onSaveClick}
        >
          {isEdit ? (
            <ContactEditForm
              initData={popupData}
              onDataChanged={onDataChanged}
            />
          ) : (
            <ContactNewForm
              initData={formDataDefaults}
              onDataChanged={onDataChanged}
            />
          )}
        </FormPopup>
      </div>
    </div>
  );
};
